import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';

import css from './P.module.css';

export const P = React.forwardRef((props, ref) => {
  const { className = null, rootClassName = null, children = null, ...otherProps } = props;
  const classes = classNames(rootClassName || css.p, className);

  return <p className={classes} {...otherProps} ref={ref}>{children}</p>;
});

P.displayName = 'P';

P.propTypes = {
  rootClassName: string,
  className: string,
  children: node,
};
